import { render, staticRenderFns } from "./RedeemRewardFinish.vue?vue&type=template&id=6fba9bb1&scoped=true&lang=pug&"
import script from "./RedeemRewardFinish.vue?vue&type=script&lang=js&"
export * from "./RedeemRewardFinish.vue?vue&type=script&lang=js&"
import style0 from "./RedeemRewardFinish.vue?vue&type=style&index=0&id=6fba9bb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba9bb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VIcon,VRow,VSkeletonLoader})
